module.exports = __webpack_public_path__ + "img/wangzhaojia.2cc6985a.jpg";